import RoadsApi from '@/services/api/Roads'
import TownsApi from '@/services/api/Towns'
import MapBox from '../services/MapBox'
import MapBuilder from '../services/MapBuilder'

export default {
  name: 'road',
  props: {
    siteName: String
  },
  data() {
    return {
      map: null,
      town: this.$route.params.town,
      breadcrumb:[],
      roads: [],
      townInfo: [],
      townMaps: [],
      roadHeaders: [
        { text: 'Road', value: 'name' },
        { text: 'Class 6', value: 'class6'},
        { text: 'Status', value: 'closed'},
        { text: 'Add / Remove', value: 'name' } 
      ],
      roadHoverId: null
    }
  },
  async created() {
  },
  async mounted () {
    // load mapbox
    await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js');
    await this.loadRoads();
    await this.loadTownInfo();
    this.buildMap();
    // setup breadcrumb
    this.breadcrumb = [
      {
        text: this.siteName,
        disabled: false,
        href: '/'
      },
      {
        text: 'towns',
        disabled: false,
        href: `/towns`
      },
      {
        text: this.town.replace('-', ' '),
        href: '/towns/' + this.town,
        disabled: true
      }
    ];
  },
  methods: {
    async loadRoads() {
      let townParam = this.town.replace(' ', '-');
      let roads = await RoadsApi.getRoadsByTown(townParam)
      if (roads) {
        // prepare data for view
        roads.forEach((road) => {
          // name
          road['name'] = road.geoJson.name;
          // link generation
          road['url'] = this.$route.path + '/roads/' + road.road.toLowerCase().replace(/ /g,'-').replace(/\./g,'');
          //road['surfaces'] = road.surfaceTypes;
        });
        this.roads = roads;
      }
    },

    async loadTownInfo() {
      let townParam = this.town.replace(' ', '-');
      
      // Get Town Detail
      let townInfo = await TownsApi.getTownDetail(townParam);
      this.townInfo = townInfo;
    },
    
    async buildMap() {
      let map = MapBox.createMap();

      let townGeo = this.townInfo.geoJson,
          mapBounds = MapBox.getMapBounds(townGeo),
          root = this;

      map.fitBounds(mapBounds, { padding: { top: 20, left: 350, bottom: 20, right: 20 }, duration: 0 });
      map.on('load', () => {
        // town layer
        map.addLayer({
            'id': 'towns',
            'type': 'fill',
            'source': {
                'type': 'geojson',
                'data': townGeo
            },
            'paint': {
                'fill-color': 'rgba(200, 100, 240, 0.1)',
                'fill-outline-color': 'rgba(200, 100, 240, 1)'
            }
        });
        
        this.roads.forEach((road) => {
          road.isInMap = MapBuilder.isRoadInMyMap(road);

          let roadGeo = road.geoJson;
          
          map.addLayer({
              'id': road.name,
              'type': 'line',
              'source': {
                'type': 'geojson',
                'data': roadGeo
              },
              'paint': {
                'line-color': road.class6 == true ? MapBox.settings.lineColorClass6 : MapBox.settings.lineColor, //'#ba671e',
                'line-width': 3,
                'line-opacity': MapBox.settings.lineOpacity
              }
          });

          map.on('mouseleave', road.name, function() {
            setTimeout(() => root.roadHoverId = null, 500);
          });
          
          map.on('mouseenter', road.name, function() {
            root.roadHoverId = road.name;
          });
        });
      });

      this.map = map;
    },

    mapHighlight(road, highlight) {
      MapBox.highlightRoad(this.map, road, highlight);
    },

    addRoadToMap(road) {
      MapBuilder.addRoad(road);
      road.isInMap = true;
    },
    
    removeRoadFromMyMap(road) {
      MapBuilder.removeRoad(road);
      road.isInMap = false;
    },

    viewRoadPage(url) {
      window.location.href = url;
    },
  }
}